import 'whatwg-fetch';

export default class PreferredUnivManager {

    send(){

        /* Cookie */
        var univList = dn.segments.schoolChoices.find();
        if(!univList) return;

        dn.db.searchOffers({id : univList})
        .then(ans => {

            let list = [];
            
            // 並び替え
            univList.forEach(univ => {
                let target = ans.hits.find(hit => hit.id === univ );

                if (target) {
                    list.push({
                        bosyutaniCd: target.id,
                        univNm: target.university_name,
                        gakubuNm: target.faculty_name,
                        gakkaNm: target.department_name,
                        nitteiNm: target.schedule_name,
                        hoshikiNm: target.examination_method_name
                    });
                }
            });

            this.onFetch(list);
        })
        .catch(error => {

        });
    }

    async onFetch(list) {

        const seisekiApiConfig = dn.$store.getters['config/seisekiApi'];
        /* 呼び出し先URL（生徒機能からの呼び出し） */
        // 本番環境
        const productionUrl = seisekiApiConfig.domain.manabi + 'cmp/services/public/stdtShibokoInfo';
        // ios11対応
        const newRefUrl = seisekiApiConfig.domain.dn;

        if (!list) { return; }

        let dbStates = dn.$store.getters['ls/at']('db_states', {});
        if(!dbStates) return;

        var targetExamId = seisekiApiConfig.examId.dn.replace("{GAKUNEN}", "K3");
        
        var targetRegDate = await this.getRegDate(targetExamId);

        let request = {
            serviceId: 2,
            examId : targetExamId,
            stdt: {
                seiseki: {
                    details: {
                        shiboList: {
                            cmpsSiboList: list
                        }
                    }
                }
            },
            regDate : targetRegDate
        }

        window.fetch(productionUrl, {
            credentials : 'include',
            method : 'PUT',
            mode : 'cors',
            headers : {
                'Accept' : 'application/json',
                'Content-Type': 'application/json'
            },
            body : JSON.stringify(request),
            referrer : newRefUrl,
            referrerPolicy : 'no-referrer-when-downgrade'
        }).then(ret => {
            //
        }).catch(error => {
            dn.$alert('エラーが発生したため志望校をDB連携できませんでした。');
        });
    }

    getRegDate(examId) {
        /*
        let request = {
            serviceId: 2,
            examId : examId
        };

        return fetch(testUrl, {
            credentials : 'include',
            method : 'POST',
            mode : 'cors',
            headers : {
                'Accept' : 'application/json',
                'Content-Type': 'application/json'
            },
            body : JSON.stringify(request),
            referrer : refUrl,
            referrerPolicy : 'no-referrer-when-downgrade'
        }).then( ans => {
            return ans.json();
        }).then( ret => {
            return ret.regDate;
        }).catch(error => {
            
        });
        */

        let currentDate = new Date();
        let regDate = currentDate.getFullYear() + 
                        ("0" + (currentDate.getMonth() + 1)).slice(-2) + 
                        ("0" + currentDate.getDate()).slice(-2) +
                        ("0" + currentDate.getHours()).slice(-2) +
                        ("0" + currentDate.getMinutes()).slice(-2) +
                        ("0" + currentDate.getSeconds()).slice(-2) +
                        ("00" + currentDate.getMilliseconds()).slice(-3);
        
        return regDate;
    }
}



// WEBPACK FOOTER //
// ./src/js/models/PreferredUnivManager.js